// extracted by mini-css-extract-plugin
export default {"componenteBtn":"Button_componenteBtn__w+n4S","btn_Cadastro":"Button_btn_Cadastro__kstIq"};